import Services from './base-services'

const service = new Services('userSkin')
import mapParameters from '../utils/map-parameters'

interface ISavePackCreate {
    active: boolean|number;
    name : string;
    type : string;
    price?: number;
}
interface ISavePackUpdate {
    id: number;
    active: boolean|number;
    name : string;
    type : string;
    price?: number;
}

export default {
    getAllActivePacks() {
        return service.get('getAllActivePacks')
    },
    getAllFreeSkins() {
        return service.get('getAllFreeSkins')
    },
    getAllSkinsByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllSkinsByUser', params)
    },
    getAllByUserAndFree(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllByUserAndFree', params)
    },
    getAllFreePacks() {
        return service.get('getAllFreePacks')
    },
    getPagePaySkin(number: number, size?: number) {
        const params = mapParameters({
            number: number ? number : 0,
            size: size ? size : 15
        })
        return service.get('getPagePaySkin', params)
    },
    getSelectedByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getSelectedByUser', params)
    },
    savePack(params: ISavePackCreate|ISavePackUpdate) {
        return service.post('savePack', params)
    },
    saveSkinCreate(skinPackId: number|string, active: boolean|number, name: string) {
        const params = {
            skinPack: {
                id: skinPackId
            },
            active,
            name
        }
        return service.post('saveSkin', params)
    },
    saveSkinUpdate(skinId: number|string, skinPackId: number|string, active: boolean|number, name: string) {
        const params = {
            id: skinId,
            skinPack: {
                id: skinPackId
            },
            active,
            name
        }
        return service.post('saveSkin', params)
    },
    saveResourceCreate(skinId: number|string, resourceUrl: string, format: string, type: string) {
        const params = {
            skin: {
                id: skinId
            },
            resourceUrl,
            format,
            type
        }
        return service.post('saveResource', params)
    },
    saveResourceUpdate(resourseId: number|string, skinId: number|string, resourceUrl: string, format: string, type: string) {
        const params = {
            id: resourseId,
            skin: {
                id: skinId
            },
            resourceUrl,
            format,
            type
        }
        return service.post('saveResource', params)
    },
    saveUserSkinCreate(userId: number|string, skinId: number|string) {
        const params = {
            user: {
                id: userId
            },
            skin: {
                id: skinId
            }
        }
        return service.post('saveUserSkin', params)
    },
    saveUserSkinUpdate(userSkinId: number|string, userId: number|string, skinId: number|string, active: boolean|number, selected: boolean|number) {
        const params = {
            id: userSkinId,
            user: {
                id: userId
            },
            skin: {
                id: skinId
            },
            active,
            selected
        }
        return service.post('saveUserSkin', params)
    },
    selectUserSkin(userId: number|string, skinId: number|string) {
        const params = {
            user: {
                id: userId
            },
            skin: {
                id: skinId
            }
        }
        return service.post('selectUserSkin', params)
    },
    deleteUserSkin(userId: number|string, skinId: number|string) {
        const params = {
            user: {
                id: userId
            },
            skin: {
                id: skinId
            }
        }
        return service.post('deleteUserSkin', params)
    }
}
